import React from 'react';
import './styles.css';
import 'primeicons/primeicons.css';
import useNavegacao from '../../hooks/useNavegacao';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';

const PermissaoVendedor = ({ rowData, botoesDisabled }) =>{
    const { navegarParaVisualizarContrato, navegarParaEditarContrato, navegarParaCadastrarDependentes, navegarParaCadastrarServicosAdicionais } = useNavegacao();

    return(<div className="p-grid p-fluid">
        <>
            <button className="botoes p-col pi pi-eye" onClick = {() => navegarParaVisualizarContrato(rowData.Inscricao)} type= "button" title='ver'>
            </button>

            <button disabled={botoesDisabled} className="botoesVerdes p-col pi pi-pencil" onClick = {()=> navegarParaEditarContrato(rowData.Inscricao)} type= "button" title='editar'>
            </button>

            <button disabled={botoesDisabled} className="botoesLaranjas p-col pi pi-users" onClick = {()=> navegarParaCadastrarDependentes(rowData.Inscricao)} type= "button" title='dependentes'>
            </button>

            <button disabled={botoesDisabled} className="botoesCiano p-col pi pi-shopping-cart" onClick = {() => navegarParaCadastrarServicosAdicionais(rowData.Inscricao)} type= "button" title='serviços adicionais' >
            </button>
        </>

    </div>);
};

const PermissaoCobrador = ({ rowData }) =>{
    const { navegarParaCobrancaAssociado } = useNavegacao();

    return(<div className="lista-contratos-botoes">
        <button onClick = {()=>navegarParaCobrancaAssociado(rowData.Inscricao)} type= "button" title='cobrança'>
        Cobrança
        </button>
    </div>);
};

const PermissaoDefault = ({ rowData }) =>{
    const { navegarParaVisualizarAssociado } = useNavegacao();

    return(<div className= "botoes-default">
        <button className='botoes pi pi-eye' onClick = {()=> navegarParaVisualizarAssociado(rowData.Inscricao)} type= "button" title='ver'>
        </button>
    </div>);
};

export default function ActionBodyEditarTabela(rowData){
    const permissao = decriptObjectOnLocalStorage('PERM') === 1 || decriptObjectOnLocalStorage('PERM')===12 ? decriptObjectOnLocalStorage('PERM') : 'default';

    const botoesDisabled = rowData.Status === 'Ativo' || rowData.Aceite == 'S' || rowData.DataPagamento != 'Não identificado' || rowData.payzentokencard;

    const permissaoCondicao = {
        1: <PermissaoVendedor rowData={rowData} botoesDisabled={botoesDisabled} />,
        12:<PermissaoCobrador rowData={rowData} />,
        default: <PermissaoDefault rowData={rowData} />             
    };

    return permissaoCondicao[permissao];
}
